import React from 'react'
import { observer } from 'mobx-react-lite'
import ContentHtml from '../../../components/content/ContentHtml/ContentHtml.component'
import { MDBCard, MDBCardBody, MDBCardTitle, MDBCol, MDBRow } from 'mdb-react-ui-kit'

const PointsBreakdown = ({ coverages, isLoading }) => {
  const formatNumber = (points, pos) => {
    points = `${parseFloat(points)}`.split('.')
    let remainder = points.length === 1 ? '000' : points.pop().substr(0, 3)

    for (let i = pos - `${remainder}`.length; i > 0; i--) remainder += '0'

    return [points, remainder].join('.')
  }

  return (
    <MDBCard id='PointsBreakdownComponent' className='card-cascade narrower points-component'>
      <MDBCardBody>
        <MDBCardTitle>Points Details</MDBCardTitle>
        <MDBRow>
          <MDBCol size='12' className='pip-details'>
            <ContentHtml contentId='49' />
          </MDBCol>
        </MDBRow>
        <MDBRow>
          <MDBCol size='12'>
            <table className='points-payout'>
              <thead>
                <tr>
                  <th>Market</th>
                  <th>Coverage</th>
                  <th>Point Factor</th>
                  <th>Fixed Points</th>
                </tr>
              </thead>
              <tbody>
                {coverages.map(coverage => (
                  <React.Fragment key={'coverage-points-' + coverage.id}>
                    <tr>
                      <td>
                        <span>{coverage.coverage_category}</span>
                      </td>
                      <td>
                        <span>{coverage.coverage_name}</span>
                      </td>
                      <td>
                        <span>
                          {formatNumber(parseFloat(coverage.points.factor1) * parseInt(coverage.points.factor2), 3)}
                        </span>
                      </td>
                      <td>
                        <span>{coverage.points.setpoints || '-'}</span>
                      </td>
                    </tr>
                    {coverage.unique ? (
                      coverage.unique.map(unique => (
                        <tr key={`unique-points-${unique.id}`} className='no-border'>
                          <td></td>
                          <td
                            style={{
                              fontSize: '13px',
                              fontWeight: 500,
                              color: 'rgb(80,80,80)',
                            }}
                          >
                            &nbsp;&nbsp;&#8614;&nbsp;
                            <span>{unique.c_name}</span>
                          </td>
                          <td
                            style={{
                              fontSize: '13px',
                              fontWeight: 500,
                              color: 'rgb(80,80,80)',
                            }}
                          >
                            &nbsp;
                            <span>
                              {formatNumber(parseFloat(unique.points.factor1) * parseInt(unique.points.factor2), 3)}
                            </span>
                          </td>
                          <td
                            style={{
                              fontSize: '13px',
                              fontWeight: 500,
                              color: 'rgb(80,80,80)',
                            }}
                          >
                            <span>{unique.points.setpoints || '-'}</span>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <></>
                    )}
                  </React.Fragment>
                ))}
              </tbody>
            </table>
          </MDBCol>
        </MDBRow>
      </MDBCardBody>
    </MDBCard>
  )
}

export default observer(PointsBreakdown)
